import * as fromDatatype from '../datatype-library';

export interface bl_cms_theme_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  identifier: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_theme_hdr_RowClass implements bl_cms_theme_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  identifier: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
